module.exports = [
    { "name": "United States Dollar", "code": "USD" },
    { "name": "Euro", "code": "EUR" },
    { "name": "Australian Dollar", "code": "AUD" },
    { "name": "New Zeland Dollar", "code": "NZD" },
    { "name": "Malaysian Ringgit", "code": "MYR" },
    { "name": "Philippine peso", "code": "PHP" },
    { "name": "Iceland Króna", "code": "ISK" },
]
